import { APP_CONFIG } from "../constants/appConstants";
import { auth } from "./firebaseApi";

const SESSION_KEY = "sf_agent_session_id";

function getOrCreateSessionId() {
  try {
    const existing = localStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SESSION_KEY, id);
    return id;
  } catch {
    return `sess_${Date.now()}`;
  }
}

async function buildHeaders(contentType = "application/json") {
  const headers = {};
  if (contentType) headers["Content-Type"] = contentType;
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

async function agentFetch(path, options = {}) {
  const res = await fetch(`${APP_CONFIG.ADMIN_API_BASE_URL}/app/agent${path}`, {
    ...options,
    headers: {
      ...(await buildHeaders(options.body instanceof FormData ? null : "application/json")),
      ...(options.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error || "Agent request failed");
    err.code = data?.code;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const agentService = {
  getSessionId: getOrCreateSessionId,

  sendMessage(message, sessionId = getOrCreateSessionId()) {
    return agentFetch("/chat", {
      method: "POST",
      body: JSON.stringify({ message, sessionId }),
    });
  },

  sendFeedback({ conversationId, helpful, comment = "", sessionId = getOrCreateSessionId() }) {
    return agentFetch("/feedback", {
      method: "POST",
      body: JSON.stringify({ conversationId, helpful, comment, sessionId }),
    });
  },

  async analyzeCropPhoto(file, { question = "", sessionId = getOrCreateSessionId() } = {}) {
    const form = new FormData();
    form.append("file", file);
    if (question) form.append("question", question);
    form.append("sessionId", sessionId);
    return agentFetch("/analyze-crop", {
      method: "POST",
      body: form,
    });
  },

  getContext() {
    return agentFetch("/context", { method: "GET" });
  },
};
